import { getFileById } from "../apis/getFile";

export const getFileUrl = async (
  fileId: string
): Promise<string | undefined> => {
  try {
    const res = await getFileById(fileId);
    if (res.success && res.data) {
      return res.data;
    }
  } catch (err) {
    console.error("Failed to get file URL:", err);
  }
  return undefined;
};
